<template>
  <component :is="type" :item="item" :class="componentClass" />
</template>
<script>
import { mapState } from 'vuex'
import RepeaterMatrixTypeBody from '@/components/repeater-matrix-type-body'
import RepeaterMatrixTypeImages from '@/components/repeater-matrix-type-images'

export default {
  components: {
    RepeaterMatrixTypeBody,
    RepeaterMatrixTypeImages
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['currentSection']),
    componentClass() {
      return this.$style.component
    },
    type() {
      const type = this.item.type.replace(/\s+|_+/g, '-').toLowerCase()
      return `repeater-matrix-${type}`
    }
  }
}
</script>

<style lang="scss" module>
// .component {}
</style>
